import DocumentCard from "../../components/DocumentCard";

const reviste = [
  {
    name: "Revista Școlii 2014",
    image:
      process.env.PUBLIC_URL +
      "/documente/revistaScolii/Revista-scolii-Ulmeni-2014-prelucrata-Calin.jpg",
    linkType: "file",
    link:
      process.env.PUBLIC_URL +
      "/documente/revistaScolii/Revista-scolii-Ulmeni-2014-prelucrata-Calin.pdf",
    wide: false,
  },
  {
    name: "Revista Școlii 2015",
    image:
      process.env.PUBLIC_URL +
      "/documente/revistaScolii/revista-scolii-2015.png",
    linkType: "file",
    link:
      process.env.PUBLIC_URL +
      "/documente/revistaScolii/revista scolii 2015.pdf",
    wide: false,
  },
  {
    name: "Revista Școlii 2016",
    image: process.env.PUBLIC_URL + "/documente/revistaScolii/revista 2016.png",
    linkType: "file",
    link: process.env.PUBLIC_URL + "/documente/revistaScolii/revista 2016.pdf",
    wide: false,
  },
];

export default function RevistaScoliiPage() {
  return (
    <div className="bg-white flex flex-wrap items-center justify-center py-4">
      {reviste.map((revista, idx) => (
        <DocumentCard
          key={idx}
          {...revista}
          imgClass="object-contain bg-white"
          cardClass="bg-transparent shadow-none border-4 border-gray-300"
        />
      ))}
    </div>
  );
}
